import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function GuaranteeSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-74">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8" data-id="element-75">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} className="overflow-hidden rounded-3xl bg-gradient-to-br from-bright-orange to-gray-900 p-1" data-id="element-76">
          <div className="rounded-[22px] bg-gradient-to-br from-bright-orange to-gray-900 p-8 text-center sm:p-12 lg:p-16" data-id="element-77">
            {/* Shield icon */}
            <motion.div variants={itemVariants} className="mx-auto mb-6 inline-flex h-20 w-20 items-center justify-center rounded-full bg-white/20 backdrop-blur-sm" data-id="element-78">
              <ShieldCheckIcon className="h-10 w-10 text-white" data-id="element-79" />
            </motion.div>

            {/* Headline */}
            <motion.h2 variants={itemVariants} className="mb-4 font-heading text-3xl font-extrabold text-white sm:text-4xl" data-id="element-80">
              Garantía de 7 Días
            </motion.h2>

            {/* Description */}
            <motion.p variants={itemVariants} className="mx-auto mb-8 max-w-xl text-lg text-gray-300 sm:text-xl" data-id="element-81">
              Si no estás satisfecho con el curso, te devolvemos tu dinero.{' '}
              <span className="font-semibold text-white" data-id="element-82">Sin preguntas.</span>
            </motion.p>

            {/* Trust points */}
            <motion.div variants={itemVariants} className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:gap-8" data-id="element-83">
              <div className="flex items-center gap-2 text-gray-300" data-id="element-84">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-85" />
                <span data-id="element-86">Reembolso completo</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300" data-id="element-87">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-88" />
                <span data-id="element-89">Sin complicaciones</span>
              </div>
              <div className="flex items-center gap-2 text-gray-300" data-id="element-90">
                <CheckCircleIcon className="h-5 w-5 text-green-400" data-id="element-91" />
                <span data-id="element-92">Proceso simple</span>
              </div>
            </motion.div>

            {/* Bottom message */}
            <motion.p variants={itemVariants} className="mt-8 text-sm text-gray-400" data-id="element-93">
              Tu satisfacción es nuestra prioridad. Invierte con confianza.
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>;
}